"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiscStepDefinitions = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const z = require("zod");
const misc_1 = require("../../misc");
exports.MiscStepDefinitions = {
    AssignSigmaModelType: {
        type: 'AssignSigmaModelType',
        displayName: 'Assign Sigma Model type',
        inputSchema: z.object({
            datasheetFileId: z.string(),
            manufacturerPartNumber: z.string(),
        }),
        outputSchema: z.object({
            sigmaModelType: z.string().min(1, 'sigmaModelType must not be empty'),
        }),
    },
    RateExperience: {
        type: 'RateExperience',
        displayName: 'Rate experience',
        inputSchema: z.object({
            manufacturerPartNumber: z.string(),
            amrBoundaries: sigma_engine_shared_1.ComponentBoundarySchema.array(),
            ocBoundaries: sigma_engine_shared_1.ComponentBoundarySchema.array(),
            functions: misc_1.pkgFunctionsSchema,
            parameters: misc_1.pkgParametersSchema,
            pinout: misc_1.pkgPinoutSchema,
            resources: sigma_engine_shared_1.IComponentResourceSchema.array(),
            sigmaModelType: z.string(),
            signals: sigma_engine_shared_1.SignalSchema.array(),
        }),
        outputSchema: z.object({
            difficultyRating: z.number().min(1).max(5).nullable(),
            feedback: z.string().nullable(),
        }),
    },
    ReconcilePackages: {
        type: 'ReconcilePackages',
        displayName: 'Reconcile packages',
        inputSchema: z.object({
            manufacturerPartNumber: z.string(),
            pkgABoundaries: misc_1.reconcilePackagesPackageSchema.shape.boundaries,
            pkgAFunctions: misc_1.reconcilePackagesPackageSchema.shape.functions,
            pkgAModes: misc_1.reconcilePackagesPackageSchema.shape.modes,
            pkgAParameters: misc_1.reconcilePackagesPackageSchema.shape.parameters,
            pkgAPinout: misc_1.reconcilePackagesPackageSchema.shape.pinout,
            pkgAResources: misc_1.reconcilePackagesPackageSchema.shape.resources,
            pkgASigmaModelType: misc_1.reconcilePackagesPackageSchema.shape.sigmaModelType,
            pkgASignals: misc_1.reconcilePackagesPackageSchema.shape.signals,
            pkgBBoundaries: misc_1.reconcilePackagesPackageSchema.shape.boundaries,
            pkgBFunctions: misc_1.reconcilePackagesPackageSchema.shape.functions,
            pkgBModes: misc_1.reconcilePackagesPackageSchema.shape.modes,
            pkgBParameters: misc_1.reconcilePackagesPackageSchema.shape.parameters,
            pkgBPinout: misc_1.reconcilePackagesPackageSchema.shape.pinout,
            pkgBResources: misc_1.reconcilePackagesPackageSchema.shape.resources,
            pkgBSigmaModelType: misc_1.reconcilePackagesPackageSchema.shape.sigmaModelType,
            pkgBSignals: misc_1.reconcilePackagesPackageSchema.shape.signals,
        }),
        outputSchema: misc_1.reconcilePackagesPackageSchema,
    },
};
//# sourceMappingURL=misc-steps.js.map